import { defineStore } from 'pinia'
import { setLocalStorage, getLocalStorage } from "@/utils/common";

/**
 * 精确数字处理工具
 */
const DecimalUtils = {
    PRECISION: 8, // 统一精度配置

    // 将字符串或数字转换为数字类型
    toNumber(value, defaultValue = '0') {
        const num = Number(value || defaultValue);
        return Number.isFinite(num) ? num : 0;
    },

    // 精确加法
    add(num1, num2) {
        const factor = Math.pow(10, this.PRECISION);
        const n1 = Math.round(this.toNumber(num1) * factor);
        const n2 = Math.round(this.toNumber(num2) * factor);
        return (n1 + n2) / factor;
    },

    // 格式化数字为字符串
    toString(num) {
        return this.toNumber(num).toString();
    }
};

export const useUserStore = defineStore("userStore", {
    state: () => ({
        twa_id: "", // 邀请码
        balance: 0, // 余额
        dividends: 0, // 分红
        points: 0, // 积分
        referrals: "", // 邀请人数
        nickname: "",
        username: "",
        mobile: '', //手机号
        twa_premium: 0, // 会员
        task01: 0, // 是否开启挖矿
        task02: 0, // 已使用的邀请人数
        ton_address: "", // 钱包地址
        nowtime: 0, // 服务端时间
        profit: 0, // 每秒产出 = 免费算力➕租用算力
        hashrate: 0, // 算力哈希 = 免费算力➕租用算力
        await_claim: "", // 待领取的
        withdraw_address: "", //提现地址
        withdraw_record: [], //提现记录
        web_withdraw_record: [], //web提现记录
        commission: 0, //佣金
        payment_info: "", // 支付信息
        payment_type: "", // 支付类型
        star_pay: 0, //购买次数
        share_group_nums: getLocalStorage("share_group_nums"), // 分享组数量
        extraData: {} // 用于存储额外的、未预定义的字段
    }),
    actions: {
        initAmount(balance, points) {
            this.balance = balance;
            this.points = points;
        },
        initMiner(profit, hashrate) {
            this.profit = profit;
            this.hashrate = hashrate;
        },
        initAwaitClaim(await_claim) {
            this.await_claim = await_claim;
        },
        initWithdrawAddress(withdraw_address) {
            this.withdraw_address = withdraw_address;
        },
        initWithdrawRecord(withdraw_record) {
            this.withdraw_record = withdraw_record;
        },
        initWithdrawWebRecord(withdraw_record) {
            console.log(withdraw_record);

            this.web_withdraw_record = withdraw_record;
        },
        addNowtime() {
            this.nowtime++;
        },
        setBalanceRaw(balance) {
            this.balance = Number(balance);
        },
        // 更新余额，传入负数就是扣除
        setBalance(update_count) {
            if (update_count == 0) {
                return;
            }
            if ((this.balance + update_count) < 0) {
                return;
            }
            const cacheKey = "google_b";
            let localValue = parseInt(getLocalStorage(cacheKey) || '0', 10);
            let newValue = localValue + update_count;
            setLocalStorage(cacheKey, newValue.toString());
            this.balance = this.balance + update_count;
        },
        addShareGroupNum() {
            this.share_group_nums = Number(this.share_group_nums) + 1;
        },
        // 更新积分，传入负数就是扣除
        setPoints(update_count) {
            if (update_count == 0) {
                return;
            }
            if ((this.points + update_count) < 0) {
                return;
            }
            const cacheKey = "google_p";
            let localValue = parseInt(getLocalStorage(cacheKey) || '0', 10);
            let newValue = localValue + update_count;
            setLocalStorage(cacheKey, newValue.toString());
            this.points = this.points + update_count;
        },
        setTonAddress(address) {
            this.ton_address = address
        },
        setPaymentInfo(payment_info, payment_type) {
            this.payment_info = payment_info
            this.payment_type = payment_type
        },
        setTask01(data) {
            this.task01 = data
        },
        setDATA(data) {
            for (const key in data) {
                if (key in this.$state && key !== 'extraData') {
                    this[key] = data[key];
                } else {
                    // 将未预定义的字段存储在 extraData 中
                    this.extraData[key] = data[key];
                }
            }
        },
        // 用于安全地获取任何用户数据的方法
        getUserData(key) {
            if (key in this.$state && key !== 'extraData') {
                return this[key];
            } else if (key in this.extraData) {
                return this.extraData[key];
            }
            return undefined;
        },
        updateBalance(input_amount) {
            this.balance = this.balance - input_amount;
        },
        /**
        * 更新余额，支持正数增加和负数扣除
        * @param {number} update_count 更新数量
        * @returns {boolean} 更新是否成功
        */
        setBalance3(update_count) {
            if (update_count === 0) return false;

            const newBalance = DecimalUtils.add(this.balance, update_count);
            if (newBalance < 0) return false;

            this.balance = newBalance;
            return true;
        },

        /**
         * 更新积分，支持正数增加和负数扣除
         * @param {number} update_count 更新数量
         * @returns {boolean} 更新是否成功
         */
        setPoints3(update_count) {
            if (update_count === 0) return false;

            const newPoints = DecimalUtils.add(this.points, update_count);
            if (newPoints < 0) return false;

            this.points = newPoints;
            return true;
        },
    }
})
